<!--
 * @Author: wsx
 * @Date: 2022-01-22 14:47:06
 * @LastEditTime: 2023-01-10 19:01:26
 * @LastEditors: zhaoshuai 894028693@qq.com
 * @Description:人脸识别
-->
<template>
  <el-container class="FaceDetect">
    <div class="left-box">
      <div class="video-box">
        <h-card class="tree-card" title="监控点" :body-style="treeCard">
          <el-input
            v-model="filterText"
            placeholder="请输入关键词"
            class="input-with-select"
          >
            <template #prefix>
              <i class="iconfont icon-31sousuo"></i>
            </template>
          </el-input>
          <div class="tree-box">
            <el-tree
              ref="treeRef"
              :data="treeData"
              :props="{ label: 'name' }"
              node-key="id"
              highlight-current
              :default-expanded-keys="[rootNodeKey]"
              @current-change="currentChange"
              :expand-on-click-node="true"
              :filter-node-method="filterNode"
            >
              <template #default="{ data, node }">
                <span
                  class="camera-icon"
                  :style="{
                    color:
                      data.deviceLineStatus == '0'
                        ? '#12e9f8'
                        : data.deviceLineStatus == '1'
                        ? '#dddddd'
                        : '#f55252',
                  }"
                  ><h-icon v-if="data.cameraId" icon="icon-shexiangtou"
                /></span>

                <span @dblclick="treedblclick(data, node)">{{
                  node.label
                }}</span>
              </template>
            </el-tree>
          </div>
        </h-card>
        <div class="video-card">
          <h-video
            v-model:videoConnected="videoConnected"
            ref="cameraRef"
          ></h-video>
        </div>
      </div>
      <h-card class="video-record" title="实时过车" :empty="false">
        <div
          class="video-record-body"
          ref="vueScrollbar"
          @scroll.passive="getScroll($event)"
          @mousewheel.passive="handleScroll"
        >
          <el-table height="180" @row-click="rowClick" :data="listData">
            <el-table-column fixed label="车牌图片" prop="imageUrl">
              <template #default="{ row }">
                <el-image
                  :src="row.plateUrlHttp"
                  style="cursor: pointer"
                ></el-image
              ></template>
            </el-table-column>
            <el-table-column label="车牌号码" prop="">
              <template #default="{ row }">
                <h-car-plate
                  :type="row.plateColor"
                  v-model:colorData="plateColorList"
                  title=""
                  >{{ row.plateNo }}</h-car-plate
                >
                <!-- <div
                  class="carNumber"
                  :style="{
                    border: `1px solid ${row.plateColorDesc}`,
                  }"
                >
                  <div
                    :style="{
                      background: row.plateColorDesc,
                      color: '#fff',
                    }"
                  >
                    {{ row.plateNo }}
                  </div>
                </div> -->
              </template>
            </el-table-column>
            <el-table-column label="抓拍地点" prop="">
              <template #default="{ row }">
                {{ row.deviceName }}
              </template>
            </el-table-column>
            <el-table-column label="行驶方向" prop="">
              <template #default="{ row }">
                <span>{{ row.directionName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="过车车道" prop="">
              <template #default="{ row }">
                <span>{{ row.laneNo }}</span>
              </template>
            </el-table-column>
            <el-table-column label="过车时间" prop="passTime" width="180">
              <template #default="{ row }">
                <span>{{
                  moment(parseInt(row.passTime)).format("YYYY-MM-DD HH:mm:ss")
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="车辆类型" prop="vehicleClassParent ">
              <template #default="{ row }">
                <span>{{ row.vehicleClassName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="车辆品牌" prop="vehicleBrand ">
              <template #default="{ row }">
                <span>{{ row.vehicleModel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="抓拍照片" prop="creator">
              <template #default="{ row }">
                <!-- <span>{{ row.vehicleLog }}</span> -->
                <el-image :src="row.vehicleUrlHttp"></el-image>
              </template>
            </el-table-column>
            <!-- <el-table-column label="驾驶行为" prop="creator">
              <template> 无 </template>
            </el-table-column> -->
          </el-table>
        </div>
      </h-card>
    </div>
    <h-card class="card-alarm" title="识别警告">
      <h-table
        ref="alarmTableRef"
        v-model:columns="columns"
        :method="getFindByCondition"
        :params="tableParams"
        :showPopover="false"
        :paging="false"
        :autoload="false"
        :showLoading="false"
        style="height: 100%"
      >
        <template #biz1="{ row }">
          <div class="table-role" @click="clickAlarmDetial(row)">
            <h-car-plate class="plateNo" :type="99">
              {{ row.biz1 }}
            </h-car-plate>
          </div>
        </template>

        <template #pictureUrl="{ row }">
          <div class="table-role" @click="clickImg(row.pictureUrl)">
            <img style="width: 100%; height: 85px" :src="row.pictureUrl" />
          </div>
        </template>
        <template #alarmTime="{ row }">
          <div class="table-role">
            {{ moment(parseInt(row.alarmTime)).format("YYYY-MM-DD HH:mm:ss") }}
          </div>
        </template>
      </h-table>
    </h-card>
    <!-- <el-dialog title="查看大图" v-model="ckdtShow" width="425px">
      <div
        style="display:flex;justify-content: center;align-items: center; position: relative;
      z-index: 200;"
      >
        <img style="height:100%;width:100%" :src="imagePartUrl" />
      </div>
    </el-dialog> -->
    <carDetailDialog
      v-if="carDetailVisible"
      v-model:visible="carDetailVisible"
      :itemInfo="carDetailItem"
      @closeDetial="showVideo"
    ></carDetailDialog>
    <h-big-picture
      :pictureUrl="pictureUrl"
      @closeBigPicture="closeBigPicture"
      v-model:visible="bigPictureVisible"
    ></h-big-picture>
  </el-container>
</template>
<script>
import {
  defineComponent,
  computed,
  reactive,
  toRefs,
  watch,
  ref,
  onUnmounted,
  watchEffect,
} from "vue";
import moment from "moment";
import HVideo from "@/components/HVideo";
import { getMenutree } from "@/api/system/region.js";
import {
  queryTreeAreaVideo,
  playVideo,
  getSubType,
} from "@/api/videoControl/videoApi.js";
import HCard from "@/components/global/HCard.vue";
import client from "@/plugins/videoClient/videoClient.js";
import { getDict } from "@/api/constant";
import { formatDateHMSSJC, formatDateHMS } from "@/utils/index.js";
import {
  recordWithTotal,
  propRetrievalV2,
} from "@/api/smartApplication/smartApplicationApi.js";
import { getFindByCondition } from "@/api/alarmCenter/alarmCenter.js";
export default defineComponent({
  name: "FaceDetect",
  components: { HVideo, HCard },
  props: {},
  setup(props, { emit }) {
    const state = reactive({
      carDetailVisible: false,
      carDetailItem: {},
      ckdtShow: false,
      dataSource: [],
      imagePartUrl: "",
      filterText: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      rootNodeKey: -1,
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      treeOrganPerson: [],
      columns: [
        { label: "车牌图片", slot: "carImg" },
        { label: "车牌号码", slot: "carNumber" },
        { label: "抓拍地点", prop: "name" },
        { label: "行驶方向", prop: "name" },
        { label: "过车车道", prop: "name" },
        { label: "过车时间", prop: "name" },
        { label: "车辆类型", prop: "name" },
        { label: "车辆品牌", prop: "name" },
        { label: "车标", prop: "name" },
        { label: "驾驶行为", prop: "name" },
      ],
      tableForm: {
        beginTime: "",
        endTime: "",
        limit: 50,
      },
      videoData: {},
      treeData: [],
      timeDate: "",
      deviceIds: [],
      listData: [],
      time: null,
      plateColorList: [],
      videoConnectedTime: null,
      videoConnected: false,
      tableParams: {
        type: "3", //, 2:人脸 3:车辆
        deviceId: [],
        startTime: formatDateHMS(new Date().getTime() - 1000 * 120),
        endTime: formatDateHMS(new Date().getTime() + 1000 * 20),
      },
      columns: [
        {
          label: "车牌号",
          prop: "name",
        },
        {
          label: "抓拍照",
          slot: "pictureUrl",
        },
        {
          label: "告警点位",
          prop: "time",
        },
        {
          label: "告警时间",
          slot: "alarmTime",
        },
      ],
      bigPictureVisible: false,
      pictureUrl: "",
    });
    const refData = toRefs(state);
    const treeRef = ref(null);
    const alarmTableRef = ref(null);
    const cameraRef = ref(null);
    const vueScrollbar = ref(null);
    watchEffect(() => {
      if (state.videoConnected) {
        clearInterval(state.videoConnectedTime);
      }
    });
    state.videoConnectedTime = setInterval(() => {
      state.videoConnected =
        window.localStorage.getItem("videoConnected") === "true";
    }, 1000);
    if (!state.videoConnected) client.connect("ws://127.0.0.1:4502");
    const queryOrganPersonListAsycn = async () => {
      const result = await getMenutree();
      const treeData = [result.data];
      state.treeOrganPerson = treeData;
      queryRealVideoTreeAsync();
    };
    // 获取区域树中所有摄像头数据
    const queryRealVideoTreeAsync = async () => {
      const params = {
        subType: "1",
      };
      const res = await getSubType(params);
      // const res = await queryTreeAreaVideo();
      state.videoData = res;
      const arrayGroup = arrayGroupBy(state.videoData.cameraBaseDtls, "areaId");
      const changeArrayGroup = {};
      arrayGroup.forEach((item) => {
        item.forEach((it) => {
          it.name = it.cameraName;
        });
        changeArrayGroup[item[0].areaId] = item;
      });
      const changeArrayGroupArray = Object.keys(changeArrayGroup);
      const getChildren = (obj) => {
        for (const key in obj) {
          if (key === "children") {
            obj[key].forEach((item) => {
              getChildren(item);
              if (changeArrayGroupArray.includes(item.id + "")) {
                changeArrayGroup[item.id].forEach((it) => {
                  item.children.push(it);
                });
              }
            });
          }
        }
      };
      getChildren(state.treeOrganPerson[0]);
      state.treeData = state.treeOrganPerson;
      const resCarColor = await getDict("car_card_color");
      state.plateColorList = resCarColor.dict;
    };
    queryOrganPersonListAsycn();
    const arrayGroupBy = (list, groupId) => {
      const sorted = groupBy(list, (item) => {
        return [item[groupId]];
      });
      return sorted;
    };
    const groupBy = (arr, f) => {
      const groups = {};
      arr.forEach((o) => {
        const group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map((group) => {
        return groups[group];
      });
    };
    // 树的筛选
    watch(
      () => state.filterText,
      (v) => {
        treeRef.value && treeRef.value.filter(v);
      }
    );
    // treedblclick
    const treedblclick = async (item, node) => {
      if (cameraRef.value) {
        if (item.cameraId) {
          const params = {
            cameraId: item.cameraId,
          };
          state.deviceIds.unshift(item.otherId);
          const res = await playVideo(params);
          cameraRef.value.play(res.result);
          if (state.timeDate === "") {
            state.timeDate = new Date();
            setIntervalClick();
          }
        }
      }
    };
    // 当前选中节点变化时触发的事件
    const currentChange = async (item, nodes) => {
      console.log(item, 5655555);
      state.currentNode = item;
    };
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    };

    const scrollWrapper = computed(() => vueScrollbar.value);
    const handleScroll = (e) => {
      console.log(
        "%c [ e ]-139",
        "font-size:13px; background:pink; color:#bf2c9f;",
        e
      );
      const eventDelta = e.wheelDelta || -e.deltaY * 40;
      const $scrollWrapper = scrollWrapper.value;
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4;
    };
    const getScroll = (e) => {
      const evt = e.target;
      if (
        evt.scrollWidth > evt.clientWidth &&
        evt.scrollLeft + evt.clientWidth === evt.scrollWidth
      ) {
        emit("scrollBottom", e);
      }
    };
    const setIntervalClick = () => {
      state.time = setInterval(async () => {
        let videoList;
        if (cameraRef.value) {
          videoList = await cameraRef.value.getCameraList();
        }

        const deviceIdsArray = state.videoData.cameraBaseDtls.filter((item) => {
          // if (videoList.cameraList.includes(item.cameraId)) {
          //   return item;
          // }
          let flag = false;
          let cameraLists = JSON.parse(videoList.cameraList);
          cameraLists.forEach((camera) => {
            if (camera === item.cameraId) {
              flag = true;
            }
          });
          if (flag) {
            return item;
          }
        });
        const deviceIds = [];

        deviceIdsArray.forEach((item) => {
          deviceIds.push(item.deviceId);
        });
        state.tableParams.deviceId = deviceIds; // 告警需要的设备
        if (deviceIds.length == 0) return;
        const params = {
          beginTime: formatDateHMS(new Date().getTime() - 1000 * 3600 * 24 * 2),
          endTime: formatDateHMS(new Date().getTime() + 1000 * 20),
          limit: 20,
          deviceIds: deviceIds,
        };
        const res = await propRetrievalV2(params);
        state.timeDate = new Date();
        if (state.listData.length < 60) {
          state.listData = res.page.list.concat(state.listData);
        } else {
          state.listData.splice(
            state.listData.length - res.page.list.length,
            res.page.list.length
          );
        }
        state.tableParams.startTime = params.beginTime;
        state.tableParams.endTime = params.endTime;
        alarmTableRef.value && alarmTableRef.value.refresh();
      }, 10000);
    };
    const rowClick = (row) => {
      cameraRef.value.hide();
      state.carDetailVisible = true;
      state.carDetailItem = row;
    };
    const showVideo = () => {
      cameraRef.value.show();
    };
    const openBigPicture = (url) => {
      cameraRef.value.hide();
      state.pictureUrl = url;
      state.bigPictureVisible = true;
    };
    const closeBigPicture = (url) => {
      cameraRef.value.show();
    };
    onUnmounted(() => {
      if (state.time) clearInterval(state.time);
    });
    return {
      ...refData,
      rowClick,
      showVideo,
      alarmTableRef,
      moment,
      currentChange,
      treedblclick,
      setIntervalClick,
      treeRef,
      cameraRef,
      filterNode,
      getScroll,
      handleScroll,
      formatDateHMSSJC,
      vueScrollbar,
      recordWithTotal,
      moment,
      getFindByCondition,
      openBigPicture,
      closeBigPicture,
    };
  },
});
</script>
<style lang="scss" scoped>
$space: 6px;
.FaceDetect {
  .tree-card {
    height: 100%;
    width: 350px;
    user-select: none;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      font-size: 14px;
    }
  }
  .video-card {
    flex: 1;
    margin-left: $space;
    overflow: hidden;
  }
  .left-box {
    flex: 1;
    overflow: hidden;
    margin-right: $space;
    @include flex-col-s-s;
    .video-box {
      flex: 1;
      width: 100%;
      overflow: hidden;
      margin-bottom: $space;

      @include flex-row-s-s;
      .video-card {
        height: 100%;
        flex: 1;
      }
    }
    .video-record {
      height: 30%;
      width: 100%;
      .video-record-body {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: auto;
        .record-list {
          height: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          flex-shrink: 0;
          padding: 5px;
          padding-top: 0;
          box-sizing: border-box;
          .record-item {
            height: 100%;
            width: 150px;
            flex-shrink: 0;
            box-shadow: var(--el-box-shadow-light);
            border-radius: 5px;
            border: 1px solid var(--el-border-color-light, #ebeef5);
            background-color: var(--el-color-white);
            margin: 5px;
            padding: 5px 10px;
            box-sizing: border-box;
            cursor: pointer;
            @include flex-col-sb-c;
            .item-text {
              text-align: center;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
  .card-alarm {
    width: 28%;
    .card-alarm-body {
      width: 100%;
      height: 100%;
    }
  }
}
.carNumber {
  // background: red;

  line-height: 32px;
  text-align: center;
  width: 96px;
  height: 32px;
  color: #fff;
  border-radius: 5px;
  div {
    border-radius: 5px;

    height: calc(100% - 2px);
    margin: 1px;
    width: calc(100% - 2px);
  }
}
</style>
